const fallbackPaginationDetails = {
  nextPageOffset: -1,
  transactionLimit: 0
};

const initialState = {
  activeTrxnHistoryData: [],
  pendingTrxnHistoryData: [],
  spendTrxnHistoryData: [],
  activeTrxnHistoryPaginationDetails: fallbackPaginationDetails,
  pendingTrxnHistoryPaginationDetails: fallbackPaginationDetails,
  spendTrxnHistoryPaginationDetails: fallbackPaginationDetails
};

function AjioCashTrxnHistoryV2(state = initialState, action) {
  const { type } = action;

  if (type === 'SET_AJIO_CASH_TRXN_HISTORY_FETCH_STATUS') {
    const { status = false } = action;
    return { ...state, success: status };
  }

  if (type === 'SET_INITIAL_ACTIVE_AJIO_CASH_TRXN_HISTORY') {
    const { initialTrxnHistoryData = {} } = action;
    const {
      activePointHistoryResponses: activeTrxnHistoryData = [],
      paginationDetails: activeTrxnHistoryPaginationDetails = fallbackPaginationDetails
    } = initialTrxnHistoryData;
    return { ...state, activeTrxnHistoryData, activeTrxnHistoryPaginationDetails };
  }

  if (type === 'SET_INITIAL_PENDING_AJIO_CASH_TRXN_HISTORY') {
    const { initialTrxnHistoryData = {} } = action;
    const {
      pendingPointHistoryResponses: pendingTrxnHistoryData = [],
      paginationDetails: pendingTrxnHistoryPaginationDetails = fallbackPaginationDetails
    } = initialTrxnHistoryData;
    return { ...state, pendingTrxnHistoryData, pendingTrxnHistoryPaginationDetails };
  }

  if (type === 'SET_INITIAL_SPEND_AJIO_CASH_TRXN_HISTORY') {
    const { initialTrxnHistoryData = {} } = action;
    const {
      spendPointHistoryResponses: spendTrxnHistoryData = [],
      paginationDetails: spendTrxnHistoryPaginationDetails = fallbackPaginationDetails
    } = initialTrxnHistoryData;
    return { ...state, spendTrxnHistoryData, spendTrxnHistoryPaginationDetails };
  }

  if (type === 'SET_FETCHED_ACTIVE_AJIO_CASH_TRXN_HISTORY') {
    const { moreTrxnHistoryData = {} } = action;
    const { activeTrxnHistoryData: existingTrxnHistoryData = [] } = state;
    const {
      activePointHistoryResponses: fetchedTrxnHistoryData = [],
      paginationDetails: activeTrxnHistoryPaginationDetails = fallbackPaginationDetails
    } = moreTrxnHistoryData;
    const newTrxnHistoryData = [...existingTrxnHistoryData, ...fetchedTrxnHistoryData];
    return {
      ...state,
      activeTrxnHistoryData: newTrxnHistoryData,
      activeTrxnHistoryPaginationDetails
    };
  }

  if (type === 'SET_FETCHED_PENDING_AJIO_CASH_TRXN_HISTORY') {
    const { moreTrxnHistoryData = {} } = action;
    const { pendingTrxnHistoryData: existingTrxnHistoryData = [] } = state;
    const {
      pendingPointHistoryResponses: fetchedTrxnHistoryData = [],
      paginationDetails: pendingTrxnHistoryPaginationDetails = fallbackPaginationDetails
    } = moreTrxnHistoryData;
    const newTrxnHistoryData = [...existingTrxnHistoryData, ...fetchedTrxnHistoryData];
    return {
      ...state,
      pendingTrxnHistoryData: newTrxnHistoryData,
      pendingTrxnHistoryPaginationDetails
    };
  }

  if (type === 'SET_FETCHED_SPEND_AJIO_CASH_TRXN_HISTORY') {
    const { moreTrxnHistoryData = {} } = action;
    const { spendTrxnHistoryData: existingTrxnHistoryData = [] } = state;
    const {
      spendPointHistoryResponses: fetchedTrxnHistoryData = [],
      paginationDetails: spendTrxnHistoryPaginationDetails = fallbackPaginationDetails
    } = moreTrxnHistoryData;
    const newTrxnHistoryData = [...existingTrxnHistoryData, ...fetchedTrxnHistoryData];
    return {
      ...state,
      spendTrxnHistoryData: newTrxnHistoryData,
      spendTrxnHistoryPaginationDetails
    };
  }

  return state;
}

export default AjioCashTrxnHistoryV2;
